<template>
    <div
        ref="scrollViewport"
        class="horizontal-scrolling-container"
        :class="wrapperClass">
        <div
            ref="scrollContent"
            class="horizontal-scrolling-container__content"
            :class="contentClass">
            <slot />
        </div>
    </div>
</template>
<script>
import ScrollBooster from 'scrollbooster';
import { mapGetters } from 'vuex';

export default {
    name: 'HorizontalScrollingContainer',
    computed: {
        ...mapGetters(['viewportIsLarge']),
    },
    props: {
        wrapperClass: {
            type: String,
            default: '',
        },
        contentClass: {
            type: String,
            default: '',
        },
    },
    data () {
        return {
            scrollBooster: null,
        };
    },
    methods: {
        initScrollBooster () {
            this.$nextTick(function () {
                const viewport = this.$refs.scrollViewport;
                const content = this.$refs.scrollContent;
                // Reset scroll styles from past initialization
                content.style = '';
                // Code that will run only after the
                // entire view has been rendered
                this.scrollBooster = new ScrollBooster({
                    viewport, // viewport container element, this parameter is required
                    content, // scrollable content element
                    direction: 'horizontal', // allow only horizontal scrolling
                    // textSelection: true,
                    onUpdate: state => {
                        // your scroll logic goes here
                        content.style.transform = `translateX(${-state.position.x}px)`;
                    },
                    shouldScroll: (state, event) => {
                        if (this.viewportIsLarge) {
                            return false;
                        }
                        // disable scroll if clicked on button
                        const isButton = [...event.target.classList].includes('collapsible__title') || event.target.nodeName.toLowerCase() === 'svg';
                        return !isButton;
                    },
                });
            });
        },
        destroyScrollBooster () {
            this.$nextTick(function () {
                if (this.scrollBooster) {
                    this.scrollBooster.destroy();
                }
            });
        },
    },
    mounted () {
        this.initScrollBooster();
    },
};
</script>

<style scoped lang="scss">
</style>
